import React, { useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const PrintComponent = ({ firstName, lastName, appId, email }) => {
  const [loaded, setLoaded] = useState(false);
  const [printed, setPrinted] = useState(false);

  useEffect(() => {
    if (loaded && !printed) {
      // Adding a timeout to ensure the print action happens after the image is fully rendered
      setTimeout(() => {
        window.print();
        setPrinted(true);
      }, 500); // You may adjust this timeout value
    }
  }, [loaded, printed]);

  return (
    <div>
      <div
        style={{
          backgroundColor: '#FFF',
          width: '100%',
          height: '100%',
          position: 'absolute',
        }}
        id="printCover"
      />
      <img
        src={`https://accounts.travpromobile.com/diploma_api/?firstName=${firstName}&lastName=${lastName}&appID=${appId}&email=${email}`}
        alt={`${firstName} ${lastName}`}
        width="100%"
        height="auto"
        onLoad={() => setLoaded(true)}
      />
      {printed && <Redirect to="/main/training" />}
    </div>
  );
};

PrintComponent.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  appId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  email: PropTypes.string.isRequired,
};

export default PrintComponent;